import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Condition } from 'Component/others';
import TableComponent from 'UiKit/table-component';
import PreviewImage from 'UiKit/preview-image';

import { useStockPromoState } from 'View/stock-promo/state';
import tableStockList from 'View/stock-promo/section/table/const/tableStockList';
import tablePromoList from 'View/stock-promo/section/table/const/tablePromoList';
import DetailWarehouseModal from 'View/stock-promo/section/detail-warehouse';
import DetailPromoModal from 'View/stock-promo/section/detail-promo';
import TableLoading from 'View/stock-promo/component/tableLoading';

import styles from './styles.module.css';

const Table = ({ data, isFetching }) => {
  const { selectedTab, filterState, updateFilterState, isOpenImagePreview, selectedImagePreview, updateState } = useStockPromoState();
  const { t } = useTranslation('stock-promo');

  const onChangePagination = (page) => updateFilterState({ page });

  const tableList = selectedTab === 'stock' ? tableStockList({ t }) : tablePromoList({ t });
  const dataSource = selectedTab === 'stock' ? data?.stocks : data?.promotions;
  const verticalAlignBody = selectedTab === 'stock' ? 'center' : 'baseline';

  const handleClosePreview = () => updateState({ isOpenImagePreview: false, selectedImagePreview: [] });

  return (
    <Box className={styles['table__container']}>
      <Condition statement={!isFetching} fallback={<TableLoading />}>
        <Box className={styles['table__wrapper']}>
          <TableComponent
            columns={tableList}
            dataSource={dataSource}
            isDataExist={data?.isDataExist}
            rowHeight="fit-content"
            paddingBodyBox="0"
            verticalAlignBody={verticalAlignBody}
            maxTableHeight="calc(100vh - 317px)"
            maxTableBodyHeight="calc(100vh - 445px)"
            tableComponentHeight="calc(100vh - 279px)"
            pagination={{
              currentPage: filterState?.page,
              totalData: data?.totalData,
              onChange: onChangePagination,
              isLoading: isFetching,
            }}
          />
        </Box>
      </Condition>

      <DetailWarehouseModal />
      <DetailPromoModal />
      <PreviewImage images={selectedImagePreview} isOpen={isOpenImagePreview} onClose={handleClosePreview} initialIndex={0} />
    </Box>
  );
};

export default Table;
